import { toMillis } from "@/lib/timestamps";
import type { DayPlanEvent } from "@amazing-wedding/shared-types";

/**
 * Stable timeline order: clock time first, then `order`, then creation time.
 *
 * The calendar planner positions blocks purely by hour/minute and no longer
 * reindexes `order` on time edits, so clock time is the source of truth for
 * chronology (exports/print read this). `order` only breaks ties between
 * same-time events; `createdAt` is the final stable tiebreak.
 */
export function compareDayPlanEvents(a: DayPlanEvent, b: DayPlanEvent): number {
  if (a.hour !== b.hour) return a.hour - b.hour;
  if (a.minute !== b.minute) return a.minute - b.minute;
  if (a.order !== b.order) return a.order - b.order;
  return toMillis(a.createdAt) - toMillis(b.createdAt);
}

export function sortDayPlanEvents(events: DayPlanEvent[]): DayPlanEvent[] {
  return [...events].sort(compareDayPlanEvents);
}
